export function Loader(props: { width: string, height: string }) {
	return (
		<div className="position-fixed loader d-flex align-items-center">
			<div className="spinner-animation border-info border-top border-left rounded-circle mx-auto mt-5" style={{width: props.width, height: props.height}}></div>
		</div>
	);
}
